import { Phone, ArrowRight, MessageSquare } from "lucide-react";
import { motion } from "framer-motion";
import { trackWhatsAppClick, trackPhoneClick } from "@/lib/analytics";

const WhatsAppIcon = ({ size = 28 }: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const FloatingCTA = () => (
  <>
    {/* Desktop floating buttons */}
    <div className="hidden md:flex fixed bottom-6 right-6 z-50 flex-col gap-3 items-end">
      <motion.a
        href="https://wa.me/33632864661?text=Bonjour%2C%20je%20souhaite%20un%20devis%20gratuit%20pour%20mon%20projet."
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackWhatsAppClick("floating_cta")}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: "spring" }}
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.95 }}
        className="flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3 rounded-full shadow-lg hover:brightness-110 transition-all animate-bounce-attention"
        aria-label="Contacter sur WhatsApp"
      >
        <WhatsAppIcon size={22} />
        <span className="font-heading font-bold text-sm">WhatsApp</span>
      </motion.a>

      <motion.a
        href="tel:+33373610242"
        onClick={() => trackPhoneClick()}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.2, type: "spring" }}
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.95 }}
        className="flex items-center gap-3 bg-primary text-primary-foreground pl-4 pr-5 py-3 rounded-full shadow-lg hover:brightness-110 transition-all animate-pulse-glow"
        aria-label="Appeler"
      >
        <Phone size={20} className="animate-shake-subtle" />
        <span className="font-heading font-bold text-sm">Appeler</span>
      </motion.a>
    </div>

    {/* Mobile sticky bottom bar */}
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ delay: 1.5, type: "spring" }}
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-lg border-t border-border safe-area-bottom"
    >
      <div className="px-3 py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] grid grid-cols-2 gap-2">
        <a
          href="tel:+33373610242"
          onClick={() => trackPhoneClick()}
          className="flex items-center justify-center gap-2 bg-primary text-primary-foreground py-3 rounded-xl font-heading font-bold text-sm active:scale-[0.97] transition-transform animate-pulse-glow"
        >
          <Phone size={16} className="animate-shake-subtle" />
          Appeler
        </a>
        <a
          href="https://wa.me/33632864661?text=Bonjour%2C%20je%20souhaite%20un%20devis%20gratuit."
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsAppClick("mobile_sticky")}
          className="flex items-center justify-center gap-2 bg-[#25D366] text-white py-3 rounded-xl font-heading font-bold text-sm active:scale-[0.97] transition-transform"
        >
          <WhatsAppIcon size={16} />
          WhatsApp
        </a>
      </div>
    </motion.div>
  </>
);

export default FloatingCTA;
